import { Id } from '../interface/AdditionalPageOptions';

/**
 * Checks given variable if its a string ant not empty
 * @param value the variable to be validated
 * @returns boolean
 */
export const isNotEmptyString = (value: any): boolean => Boolean(value && 'string' === typeof value);

/**
 * Checks given variable if its a string ant not empty
 * and if an array is provided also checks whether it includes the value
 * @param value the variable to be validated
 * @param array
 * @returns boolean
 */
export const isValidId = (value: any, array?: string[]) => {
    let result = isNotEmptyString(value);

    if (array?.length) {
        result = array.includes(value);
    }

    return result;
};

/**
 * Compare two ids
 * @param id1 Id
 * @param id2 Id
 * @returns boolean
 */
export const areIdsEqual = (id1?: Id, id2?: Id) => Boolean(id1 && id2 && id1.toString() === id2.toString());

/**
 * Wrapper/ Helper function for areIdsEqual
 * @param id1 Id
 * @param id2 Id
 * @returns boolean whether the two params are equal or not
 */
export const areIdsNotEqual = (id1?: Id, id2?: Id) => !areIdsEqual(id1, id2);

/**
 * Compare two arrays and return true if their values match
 *
 * @param arr1 array
 * @param arr2 array
 * @returns true if the array values match
 */
export const areArraysEqual = (arr1: Array<any>, arr2: Array<any>) => {
    return JSON.stringify(arr1) === JSON.stringify(arr2);
};
